

























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { WorkShiftService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { WorkShiftModel } from '@/models/config'

@Component({
    name: 'TableListWorkShifts',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListWorkShifts extends Vue {
    loading = false
    items: [WorkShiftModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'Nombre de Turno'
        },
        {
            key: 'checkin_time',
            sortable: true,
            label: 'Hora de Ingreso'
        },
        {
            key: 'lunch_time_entry',
            sortable: true,
            label: 'Hora de Salida al Refrigerio'
        },
        {
            key: 'lunch_time_ends',
            sortable: true,
            label: 'Hora de Ingreso del Refrigerio'
        },
        {
            key: 'checkout_time',
            sortable: true,
            label: 'Hora de Salida'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getWorkShiftsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getWorkShiftsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getWorkShiftsWithPagination()
    }

    async getWorkShiftsWithPagination () {
        this.loading = true
        const response = await WorkShiftService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
